import { FormControl, InputLabel, MenuItem, Select, SelectProps } from "@mui/material";
import { IGWidget, appendClass } from "../GWidget";
import _ from "lodash";
import { forwardRef, Ref, useImperativeHandle, useRef } from "react";

export type TSelectValue = string|number;
export type TSelectEvent<T extends TSelectValue> = (selected:T|null) => void;
export interface ISelectRow<T extends TSelectValue> {
    label:string;
    value:T;
}
export interface IDropdownProps<T extends TSelectValue> extends IGWidget {
    value?:T;
    defaultValue?:T;
    error?:string;
    options:ISelectRow<T>[]
    label?:string;
    onChange?:TSelectEvent<T>;
    size?:"small"|"medium"
    inputRef?:Ref<HTMLSelectElement>
}
export function getRow<T extends TSelectValue>(options:ISelectRow<T>[], value:T|undefined) : ISelectRow<T> | null {
    if (value!==undefined) return _.find(options, o => o.value===value) || null
    else return null
}
let g_selectId = 0;
const Dropdown = <T extends TSelectValue>(props:IDropdownProps<T>) => {
    const rows = props.options.map(item => (
        <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
    ))
    const id = `DDL_${g_selectId++}`
    const label = props.label ? <InputLabel id={id}>{props.label}</InputLabel> : null
    const selectProps:SelectProps<T> = {labelId:id,inputRef:props.inputRef}

    const current = getRow(props.options, props.value) || getRow(props.options, props.defaultValue)
    if (current) selectProps.value = current.value;
    else selectProps.value = ""

    if (props.onChange) selectProps.onChange = (e:any) => props.onChange?.(e.target.value)
    selectProps.size = props?.size || "small"
    return <FormControl className={appendClass("dropdown", props.className)} id={props.id}>{label}<Select {...selectProps}>{rows}</Select>
    </FormControl>
}

export default Dropdown;
